import { SafetyLocalStorage } from '@mail-core/std';
import { useSelector } from 'react-redux';
import { USER_EMAIL } from 'reactApp/appHelpers/configHelpers';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';

const MAX_SHOWS = 3;
const COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000;

const lStorage = new SafetyLocalStorage({});
const countKey = `${USER_EMAIL}|personalization_top_banner_count`;
const lastShownKey = `${USER_EMAIL}|personalization_top_banner_last_shown`;
const getShownCount = (): number => Number(lStorage.getItem(countKey)) || 0;
const getLastShown = (): number => Number(lStorage.getItem(lastShownKey)) || 0;

export const isPersonalizationTopBannerShowAllowed = (): boolean => {
    const shownCount = getShownCount();
    if (shownCount >= MAX_SHOWS) {
        return false;
    }
    const lastShown = getLastShown();
    if (!lastShown) {
        return true;
    }
    return Date.now() - lastShown >= COOLDOWN_MS;
};

export const markPersonalizationTopBannerShown = (): void => {
    lStorage.setItem(countKey, String(getShownCount() + 1));
    lStorage.setItem(lastShownKey, String(Date.now()));
};

const STATIC_PATH = `${cdnPackagesUrl}/static/cloud/promo/personalization/topBanner`;

export const usePersonalizationTopBannerImg = (space: number | undefined) => {
    const isDarkTheme = useSelector(isCurrentDarkTheme);
    const suffix = isDarkTheme ? 'Dark' : '';

    switch (space) {
        case 256:
            return `${STATIC_PATH}/personalizationTopBanner256gb${suffix}.png`;
        case 512:
            return `${STATIC_PATH}/personalizationTopBanner512gb${suffix}.png`;
        case 1:
            return `${STATIC_PATH}/personalizationTopBanner1tb${suffix}.png`;
        case 2:
            return `${STATIC_PATH}/personalizationTopBanner2tb${suffix}.png`;
        case 4:
            return `${STATIC_PATH}/personalizationTopBanner4tb${suffix}.png`;
        default:
            return `${STATIC_PATH}/personalizationTopBanner256gb${suffix}.png`;
    }
};
